import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Home, Search } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function NotFound() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box sx={{
      minHeight: '100vh',
      background: '#09090b',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 3,
      p: 4,
      textAlign: 'center'
    }}>
      <Typography
        sx={{
          fontSize: 'clamp(6rem, 20vw, 12rem)',
          fontWeight: 900,
          lineHeight: 1,
          background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #ec4899 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
        }}
      >
        404
      </Typography>
      <Typography variant="h4" sx={{ color: '#fafafa', fontWeight: 700, mt: -2 }}>
        {t('notFound.title')}
      </Typography>
      <Typography sx={{ color: '#71717a', maxWidth: 380 }}>
        {t('notFound.desc')}
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, mt: 1, flexWrap: 'wrap', justifyContent: 'center' }}>
        <Button
          variant="contained"
          startIcon={<Home size={16} />}
          onClick={() => navigate('/')}
          sx={{
            background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
            textTransform: 'none',
            fontWeight: 600,
            px: 3, py: 1.5,
            borderRadius: 2
          }}
        >
          {t('notFound.backHome')}
        </Button>
        <Button
          variant="outlined"
          startIcon={<Search size={16} />}
          onClick={() => navigate('/courses')}
          sx={{
            borderColor: 'rgba(255,255,255,0.15)',
            color: '#a1a1aa',
            textTransform: 'none',
            fontWeight: 600,
            px: 3, py: 1.5,
            borderRadius: 2,
            '&:hover': { borderColor: 'rgba(255,255,255,0.3)', color: '#fafafa' }
          }}
        >
          {t('notFound.browseCourses')}
        </Button>
      </Box>
    </Box>
  );
}
